module.exports = __webpack_public_path__ + "static/media/fantasyomatic-ui-paywall-Artboard-6@2x.67e7d6bb.png";